import classNames from "classnames/bind";
import { isEqual } from "es-toolkit/compat";
import React, { memo } from "react";
import { DataDisplayWithAdornment } from "../../../DataDisplay/_components/DataDisplayWithAdornment";
import { DateDataDisplay } from "../../../DataDisplay/DateDataDisplay";
import { IconLoading } from "../../../Icon";
import type { DateCellProps } from "../../types";
import styles from "./DateCell.module.scss";

const cx = classNames.bind(styles);

const DateCell = ({
  value,
  withTime = false,
  convertToUTC,
  isLoading,
  isBusy,
  showInvalidIndicator,
  ...restProps
}: DateCellProps) => {
  return (
    <DataDisplayWithAdornment
      adornmentSlot={({ iconProps }) => (
        <IconLoading
          speed="fast"
          {...iconProps}
        />
      )}
      showAdornment={isBusy}
      alignment={restProps.alignment}
    >
      <div className={cx("dateContainer")}>
        <DateDataDisplay
          value={value}
          showInvalidIndicator={showInvalidIndicator}
          convertToUTC={convertToUTC ?? !withTime}
          className={cx("date", { "with-time": withTime })}
          {...restProps}
        />
        {withTime ? (
          <DateDataDisplay
            value={value}
            showInvalidIndicator={showInvalidIndicator}
            convertToUTC={convertToUTC ?? !withTime}
            displayFormat="p"
            className={cx("time")}
            {...restProps}
          />
        ) : null}
      </div>
    </DataDisplayWithAdornment>
  );
};

export default memo(DateCell, isEqual);
